import { useEffect, useState } from "react";

import { X } from "lucide-react";
import { useBreakpoint } from "use-breakpoint";

import { cn } from "@/lib/utils";
import apis from "@/services/api";
import { Button } from "@/components/ui/button";
import useChatStore from "@/stores/useChatStore";
import { BREAKPOINTS } from "@/constants/defaultValue";

function SuggestedQuestionTemplates({ onClose }) {
  const setQuestion = useChatStore((store) => store.setQuestion);
  const handleAskQuestionStream = useChatStore((store) => store.handleAskQuestionStream);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const { breakpoint } = useBreakpoint(BREAKPOINTS);

  const isMobile = ["xs", "sm", "md"].includes(breakpoint);

  useEffect(() => {
    setVisible(true);
    const fetchTemplateQuestions = async () => {
      try {
        setIsLoading(true);
        const response = await apis.get("/question/template_questions?count=100");
        setCategories(response.data.questions);
      } catch (error) {
        console.error("Error fetching template questions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplateQuestions();
  }, []);

  const handleQuestionClick = (question) => {
    setQuestion(question);
    handleAskQuestionStream();
    setQuestion("");
    if (isMobile) {
      handleClose();
    }
  };

  const handleClose = () => {
    setVisible(false);
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <>
      {isMobile && <div className={cn("fixed inset-0 bg-black/50 z-40 transition-opacity duration-300", visible ? "opacity-100" : "opacity-0")} onClick={handleBackdropClick} />}
      <div
        className={cn(
          visible ? "translate-x-0" : "translate-x-full",
          "bg-white transition-all duration-300 rounded-tl-lg rounded-bl-lg shadow-lg",
          isMobile
            ? "fixed right-0 top-0 h-full shadow-lg z-50 overflow-y-auto transform transition-transform duration-300"
            : `h-[calc(100vh-100px)] overflow-y-auto transition-[width] duration-300 ${visible ? "w-64 md:w-80" : "w-0"}`
        )}
        style={{
          width: isMobile ? "280px" : undefined,
          visibility: isMobile ? (visible ? "visible" : "hidden") : "visible",
        }}
      >
        <div className="sticky top-0 bg-white z-10 flex justify-between items-center p-3 border-b">
          <h3 className="font-semibold">Gợi ý mẫu câu hỏi</h3>
          <Button variant="ghost" size="icon" onClick={handleClose} className="h-8 w-8">
            <X size={18} />
          </Button>
        </div>

        <div className="p-4 space-y-4">
          {isLoading ? (
            <div className="text-center py-4 text-sm text-gray-500">Đang tải...</div>
          ) : (
            categories.map((category, index) => (
              <Button
                key={index}
                variant="outline"
                className="w-full h-auto justify-start text-sm font-normal py-2 text-left hover:bg-gray-50 transition-colors duration-200"
                onClick={() => handleQuestionClick(category)}
              >
                {category}
              </Button>
            ))
          )}
        </div>
      </div>
    </>
  );
}

export default SuggestedQuestionTemplates;
